import { DateRangeFilter } from '@synergy/components';
import { PaloFilterModal } from '@synergy/components-palo';
import { ReactElement } from 'react';

import { OrderContactFilter } from '../../../common/components/filter/order-contact-filter';
import { OrderTypeFilter } from '../../../common/components/filter/order-type-filter';
import { SupplierFilter } from '../../../common/components/filter/supplier-filter';
import { seesCompanyOrders } from '../../../common/utils/sees-company-orders';
import { useSelector } from '../../../store/use-appstate-selector';

/** The filters the order list's endpoint takes; the list header owns the search. */
export const PaloOrdersFilter = (): ReactElement => {
    const user = useSelector(state => state.user);

    return (
        <PaloFilterModal>
            <DateRangeFilter untilField="createdAtUntil" fromField="createdAtFrom" />
            <SupplierFilter />
            {seesCompanyOrders(user) && <OrderContactFilter />}
            <OrderTypeFilter />
        </PaloFilterModal>
    );
};
